import { fetchGet } from '../service';
import { buildApiUrl } from '../../utils/build-api-url';
import type { IFilters, IResponse } from '../../types';

export async function getFilters(
  cmsNativeLanguage: string,
  pimLanguage: string,
  productIds?: number[],
  variants?: string[],
  searchTerm?: string,
): Promise<IResponse<IFilters> | null> {
  const url = buildApiUrl('filters', {
    pimLanguage,
    cmsNativeLanguage,
    productIds: productIds ? productIds.map((productId) => JSON.stringify(productId)) : undefined,
    variants,
    searchTerm: searchTerm && searchTerm.length > 0 ? searchTerm : undefined,
  });

  return fetchGet<IFilters>(url);
}
